import { AddressPost } from '../models/address-post';

import { Component, OnInit, state } from '@angular/core';
import { Router } from '@angular/router';

import { DataSharingService } from '../services/data-sharing.service';
import { CommonDataService } from '../services/common-data.service';
import { StudentService } from '../services/student.service';
import { LocationService } from '../services/location.service';
import { UserService } from '../services/user.service';
import { LoggerService } from '../services/logger.service';

import { StudentPost } from '../models/student-post';
import { State } from '../models/state';
import { FriendStudentPost } from '../models/friend-student-post';
import { LogDetail } from '../models/log-detail';
import { StudentGet } from '../models/student-get';
import { CreateLogin } from '../models/create-login';
import { StudentClassDto } from "../models/student-class-dto";

@Component({
  selector: 'app-new-student-registration',
  templateUrl: './new-student-registration.component.html',
  styleUrls: ['./new-student-registration.component.css'],
})
export class NewStudentRegistrationComponent implements OnInit {
  student: StudentPost = new StudentPost();
  astudent: StudentPost = new StudentPost();
  states: State[] = [];
  userRole = null;
  isAdmin: boolean = false;
  saving: boolean = false;
  authtoken = null;
  selectedState: State = new State();
  friendSelectedState: State = new State();
  updateUser: CreateLogin = new CreateLogin();

  isRegistered: boolean = false;
  isPreviousClasses: boolean = false;
  isRegisteringAdditional: boolean = false;
  friendStudent: FriendStudentPost = new StudentPost();
  isFullClassroomCourse: boolean = false;
  isRefresherClassroomCourse: boolean = false;
  isFullOnlineCourse: boolean = false;
  isRefresherOnlineCourse: boolean = false;
  displayModal: string = 'none';
  displayModal1: string = 'none';
  isCityForm1Disabled: boolean = true;
  isCityForm2Disabled: boolean = true;
  isStateForm1Disabled: boolean = true;
  isStateForm2Disabled: boolean = true;
  isModelChanged: boolean = false;
  isModel2Changed: boolean = false;
  courseDeliveryType: string = '';
  formComplete: boolean = false; // form complete
  msg: string = '';
  fullAddress: number = 0;
  testmode: boolean = false;
  issecond: boolean = false;
  phonemsg1: string = '';
  phonemsg2: string = '';

  constructor(
    private _router: Router,
    private _dataService: DataSharingService,
    private _commonService: CommonDataService,
    private _studentService: StudentService,
    private _locationService: LocationService,
    private _userService: UserService,
    private _logger: LoggerService
  ) {
    this.student = new StudentPost();
    this.friendStudent = new StudentPost();
    this.userRole = 1;
  }

  // validates input
  ngOnInit() {
    // get class delivery type
    this.setDefaultClassType();

    this.msg = '';

    // get session data
    this._dataService.setRegisterProgress('1');
    this._dataService.setRegisterAdditional(false);

    this.authtoken = this._dataService.getAuthToken();
    this.userRole = this._dataService.getRoleId();
    this.isAdmin =
      this.userRole == this._userService.roleAdmin ||
      this.userRole == this._userService.roleSuper;

    this.getStates();

    const defaultState = new State();
    defaultState.id = '0';
    defaultState.abbreviation = 'State';
    defaultState.name = 'State';
    this.states.splice(0, 0, defaultState);
    this.friendSelectedState = this.states[0];
    this.selectedState = this.states[0];

    let studentGot = new StudentGet();
    const astudent = this._dataService.getCurrentStudent();
    if (astudent !== null) {
      studentGot = astudent.student;
      if (studentGot != null) {
        this.student = new StudentPost();
        this.student.email = studentGot.email;
        this.student.firstName = studentGot.firstName;
        this.student.middleName = studentGot.middleName;
        this.student.lastName = studentGot.lastName;
        this.student.studentLoginId = studentGot.studentLoginId;
        this.student.id = studentGot.id;
        this.testmode = this.student.email.includes('@test.com');
      }
    }

    this.getStudent();
  }

  getStudent() {
    const gotstudent = this._studentService
      .getStudentByLogin(this.student.id, this.student.studentLoginId)
      .subscribe(
        (res) => this.getStudentSuccsessful(res),
        (error) => this.getStudentFailed(error),
        () => console.log('Get Student Complete!')
      );
  }

  getStudentFailed(error: any) {
    this.authtoken = this._dataService.getAuthToken();
    this.userRole = this._dataService.getRoleId();
  }

  getStudentSuccsessful(result: any) {
    this.student = result as StudentPost;
    this.student.phone = this.cvtPhone(this.student.phone);
    this.student.cellPhone = this.cvtPhone(this.student.cellPhone);
    if (result.address != null && result.address.state != null) {
      this.student.address.stateId = result.address.state.id;
      this.isCityForm1Disabled = false;
      this.isStateForm1Disabled = false;
      this.selectedState = this.states.find(
        (x) => x.id === result.address.state.id
      );
    }
    // this.student.yearOfBirth =  new Date(this.student.yearOfBirth).toISOString().split('T')[0];
    this._studentService
      .getStudentClasses(this.student.id) // .studentLoginId)
      .subscribe(
        (classes) => this.getClassesSuccess(classes),
        (error) => this.getClassesFailed(error),
        () => console.log('Completed!')
      ); // comment
  }

  getClassesFailed(error: any) {
    this.isPreviousClasses = false;
  }

  cvtPhone(phone: string) {
    if (phone == null) {
      return phone;
    }
    let fixPhone: string = phone.replace(/\D/g, '');
    if (fixPhone.substr(0, 1) === '1') {
      fixPhone = fixPhone.substr(1);
    }
    if (fixPhone.length >= 10) {
      fixPhone = '(' + fixPhone.substr(0, 3) + ')' + fixPhone.substr(3, 3) + '-' + fixPhone.substr(6, 4) ;
    } else {
      fixPhone = phone;
    }
    // fixPhone = fixPhone.substr(0, 10);
    return fixPhone;
  }

  getClassesSuccess(result: any) {
    this.isPreviousClasses = result.length > 0;
    this.isRegistered = false;

    if (this.isPreviousClasses && !this.isAdmin) {
      let now  = new Date();
      let today = this.formatDate(now);
        for (let i = 0, len = result.length; i < len; i++) {
        const cla = result[i] as StudentClassDto;
         if (cla.classSchedule.startDateTime > today) {
          this.isRegistered = true;
          break;
        }
      }
    }

    if (this.student.friendStudent != null) {
      this.isRegisteringAdditional = true;
      this.friendStudent = this.student.friendStudent;
      this.friendStudent.phone = this.cvtPhone(this.friendStudent.phone);
      this.friendStudent.cellPhone = this.cvtPhone(this.friendStudent.cellPhone);
    }
  }

   formatDate(date) {
    let d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    let year = d.getFullYear();

    if (month.length < 2) { month = '0' + month; }
    if (day.length < 2) { day = '0' + day; }

    return [year, month, day].join('-');
}

  getStates() {
    this._commonService.getStates().subscribe(
      (states) => this.getStatesSuccess(states),
      (error) => this.getStatesFailed(error),
      () => console.log('Completed!')
    );
  }

  getStatesSuccess(states: any) {
    this.states = states;
    const defaultState = new State();
    defaultState.id = '0';
    defaultState.abbreviation = 'State';
    defaultState.name = 'State';
    this.states.splice(0, 0, defaultState);
    this.selectedState = this.states.find((x) => x.abbreviation === 'MN');
    this.friendSelectedState = this.selectedState;
  }

  getStatesFailed(error: any) {
    this._logger
      .logError(error, 'ERROR: [new-student-registration]', 'getStates()')
      .subscribe(
        (log) => this.logSuccessful(log),
        (error) => this.logFailed(error),
        () => console.log('LogError Complete!')
      );
  }

  setModelChange(event: any) {
    // this.ValidateInput(this.student);
    this.isModelChanged = this.ValidateInput(this.student, 0);
  }

  setModel2Change(event: any) {
    this.friendToWorking();
    this.issecond = true;
    this.isModel2Changed = this.ValidateInput(this.astudent, 1);
    this.issecond = false;
    this.workingToFriend();
    this.isModelChanged = this.isModel2Changed;
  }

  friendToWorking() {
    this.astudent = new StudentPost();
    this.astudent.id = this.friendStudent.id;
    this.astudent.studentSchoolId = this.friendStudent.studentSchoolId;
    this.astudent.firstName = this.friendStudent.firstName;
    this.astudent.middleName = this.friendStudent.middleName;
    this.astudent.lastName = this.friendStudent.lastName;
    this.astudent.name = this.friendStudent.name; // Do I need to be building and sending this to db?
    this.astudent.yearOfBirth = this.friendStudent.yearOfBirth;
    this.astudent.phone = this.friendStudent.phone;
    this.astudent.cellPhone = this.friendStudent.cellPhone;
    this.astudent.email = this.friendStudent.email;
    this.astudent.address = this.friendStudent.address;
    this.astudent.contactMethodId = this.friendStudent.contactMethodId;
    this.astudent.studentTypeId = this.friendStudent.studentTypeId;
    this.astudent.studentLoginId = this.friendStudent.studentLoginId;
    this.astudent.friendStudent = null;
  }

  workingToFriend() {
    this.friendStudent = new FriendStudentPost();
    this.friendStudent.id = this.astudent.id;
    this.friendStudent.studentSchoolId = this.astudent.studentSchoolId;
    this.friendStudent.firstName = this.astudent.firstName;
    this.friendStudent.middleName = this.astudent.middleName;
    this.friendStudent.lastName = this.astudent.lastName;
    this.friendStudent.name = this.astudent.name;
    this.friendStudent.yearOfBirth = this.astudent.yearOfBirth;
    this.friendStudent.phone = this.astudent.phone;
    this.friendStudent.cellPhone = this.astudent.cellPhone;
    this.friendStudent.email = this.astudent.email;
    this.friendStudent.address = this.astudent.address;
    this.friendStudent.contactMethodId = this.astudent.contactMethodId;
    this.friendStudent.studentTypeId = this.astudent.studentTypeId;
    this.friendStudent.studentLoginId = this.astudent.studentLoginId;
  }

  getCityStateFromZipForm1(event: any) {
    this.formComplete = false;
    this.student.address.city = '';
    if (event.length > 4) {
      // this.isModelChanged = true;
      const zipCode: string = event;
      this._locationService.getCityStateFromZip(zipCode).subscribe(
        (res) => this.getCityStateFromZipForm1Successful(res),
        (error) => this.getCityStateFromZipForm1Failed(error),
        () => console.log('City/State search Complete!')
      );
    }
  }

  getCityStateFromZipForm2(event: any) {
    this.formComplete = false;
    this.friendStudent.address.city = '';
    // this.isModelChanged = true;
    // this.isModel2Changed = true;
    if (event.length > 4) {
      const zipCode: string = event;
      this._locationService.getCityStateFromZip(zipCode).subscribe(
        (res) => this.getCityStateFromZipForm2Successful(res),
        (error) => this.getCityStateFromZipForm2Failed(error),
        () => console.log('City/State search Complete!')
      );
    }
  }

  getCityStateFromZipForm1Successful(result: any) {
    this.isCityForm1Disabled = false;
    this.isStateForm1Disabled = false;
    this.student.address.city = result.city;
    this.selectedState = this.states.find((x) => x.id === result.state.id);
    this.setModelChange(result);
  }

  getCityStateFromZipForm1Failed(error: any) {}

  getCityStateFromZipForm2Successful(result: any) {
    this.isCityForm2Disabled = false;
    this.isStateForm2Disabled = false;
    this.friendStudent.address.city = result.city;
    this.friendSelectedState = this.states.find(
      (x) => x.id === result.state.id
    );
    this.setModelChange(result);
  }

  getCityStateFromZipForm2Failed(error: any) {}

  ValidateInput(student: StudentPost, which: number) {
    let phonemsg: string = '';
    this.phonemsg1 = phonemsg;
    this.phonemsg2 = phonemsg;
    const emailRegex = new RegExp(
      "[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?"
    );
    const phoneRegex = new RegExp(
      "[(]?([0,2-9][0-8][0-9])[)]?[ -.]?([0,2-9][0-9]{2})[ -.]?([0-9]{4})"
    );
//    "1?W*([0,2-9][0-8][0-9])[)]?[ -.]?([0,2-9][0-9]{2})[ -.]?([0-9]{4})"
    this.formComplete = true;
    student.yearOfBirth = '' + student.yearOfBirth;
    if (which !== 0 && (student.phone == null || student.phone === '')) {
       student.phone = '000-000-0000';
    }
    const ayear = (new Date().getFullYear() - 15).toString();
    if (
      student.firstName.length === 12 ||
      student.lastName === '' ||
      student.yearOfBirth === '' ||
      student.yearOfBirth.length !== 4 ||
      student.yearOfBirth < '1900' ||
      student.yearOfBirth > ayear ||
      student.address.address1 === '' || // || (((student.email === '') || (student.email == null)) && !this.issecond) // || (student.phone === '')
      student.address.city === '' ||
      student.address.zipCode === '' ||
      student.address.zipCode.length < 5
      // || (!emailRegex.test(student.email)) || (!phoneRegex.test(student.phone))
    ) {
      this.formComplete = false;
    }
    if (which === 0 && !this.isAdmin && (student.email == null || student.email === '')) {
      this.formComplete = false;
    }
    if (
      student.email != null &&
      student.email !== '' &&
      !emailRegex.test(student.email)
    ) {
      this.formComplete = false;
    }
    if (which === 0 && (student.phone == null || student.phone === '')) {
      this.formComplete = false;
    } else if (which !== 0 || student.phone != null || student.phone !== '') {
      student.phone = this.cvtPhone(student.phone);
      if (student.phone.length !== 13) {
        phonemsg = 'Phone # format must be (xxx)xxx-xxxx';
        this.formComplete = false;
      }
    }
    if (student.cellPhone != null && student.cellPhone !== '') {
      student.cellPhone = this.cvtPhone(student.cellPhone);
      if (student.cellPhone.length !== 13) {
        phonemsg = 'Phone # format must be (xxx)xxx-xxxx';
        this.formComplete = false;
      }
    }
    if (which === 0) {
      this.phonemsg1 = phonemsg;
    } else {
      this.phonemsg2 = phonemsg;
    }
    return this.formComplete;
  }

  saveChangedData() {
    this.msg = '';
    this._dataService.setCourseDeliveryType('');
    this.ValidateInput(this.student, 0);
    this.courseDeliveryType = '';
    if (!this.formComplete) {
      this.displayModal1 = 'block';
      return;
    }
    if (this.isRegisteringAdditional) {
      this.friendToWorking();
      this.ValidateInput(this.astudent, 1);
      this.workingToFriend();
      if (!this.formComplete) {
        this.displayModal1 = 'block';
        return;
      }
    }
    this.createStudent();
  }

  option1Selected() {
    this._dataService.setCourseDeliveryType('classroom');
    // display dialog box and return if validation fails
    this.ValidateInput(this.student, 0);
    this.courseDeliveryType = 'classroom';
    if (!this.formComplete) {
      this.displayModal1 = 'block';
      return;
    }
    if (this.isFullClassroomCourse || this.isPreviousClasses) {
      this._dataService.setClassTypeId('1');
      this._dataService.setRegisterProgress('2');
      this._dataService.setDistanceType('0');
      this.createStudent();
    } else {
      // open modal with message
      this.displayModal = 'block';
    }
  }

  option2Selected() {
    this._dataService.setCourseDeliveryType('classroom');
    this.courseDeliveryType = 'classroom';
    this._dataService.setDistanceType('0');
    //if (this.isRefresherClassroomCourse || this.isPreviousClasses) {
      this.refresherApproved();
      // this._dataService.setClassTypeId('2');
      // this._dataService.setRegisterProgress('2');
      // this._router.navigate(['select-location']);
    //} else {
      // open modal with message
    //  this.displayModal = 'block';
    //}
  }

  refresherApproved() {
    this.displayModal = 'none';
    this.ValidateInput(this.student, 0);
    if (!this.formComplete) {
      this.displayModal1 = 'block';
      return;
    }
    this._dataService.setCourseDeliveryType('classroom');
    this.courseDeliveryType = 'classroom';
    this._dataService.setClassTypeId('2');
    this._dataService.setRegisterProgress('2');
    this.createStudent();
  }

  option4Selected() {
    this._dataService.setCourseDeliveryType('classroom');
    // display dialog box and return if validation fails
    this.ValidateInput(this.student, 0);
    this.courseDeliveryType = 'classroom';
    if (!this.formComplete) {
      this.displayModal1 = 'block';
      return;
    }
    if (this.isFullClassroomCourse || this.isPreviousClasses) {
      this._dataService.setClassTypeId('1');
      this._dataService.setRegisterProgress('2');
      this._dataService.setDistanceType('1');
      this.createStudent();
    } else {
      // open modal with message
      this.displayModal = 'block';
    }
  }

  option5Selected() {
    this._dataService.setCourseDeliveryType('classroom');
    this.courseDeliveryType = 'classroom';
    this._dataService.setDistanceType('1');
    //if (this.isRefresherClassroomCourse || this.isPreviousClasses) {
      this.refresherApproved();
      // this._dataService.setClassTypeId('2');
      // this._dataService.setRegisterProgress('2');
      // this._router.navigate(['select-location']);
    //} else {
      // open modal with message
    //  this.displayModal = 'block';
    //}
  }

  //  option3Selected() {
  //   this._dataService.setCourseDeliveryType('online');
  //  this.ValidateInput();
  //   console.log('wtf');
  //    if (!this.formComplete) {
  //     this.displayModal1 = 'block';
  //     return;
  //    }
  //    if (this.isFullOnlineCourse) {
  //      this.createStudent();
  //     this._dataService.setClassTypeId('1');
  //     this._dataService.setRegisterProgress('2');
  //   } else {
  //         // open modal with message
  //         this.displayModal = 'block';
  //       }
  //   }
  //  }

  option3Selected() {
    this._dataService.setCourseDeliveryType('online');
    this.courseDeliveryType = 'online';
    if (this.isFullOnlineCourse) {
      this._dataService.setClassTypeId('1');
      this.createStudent();
    } else {
      // open modal with message
      this.displayModal = 'block';
    }
  }

  //  option4Selected() {
  //    this._dataService.setCourseDeliveryType('online');
  //    this.courseDeliveryType = 'online';
  //    console.log('wtf');
  //    if (this.isRefresherOnlineCourse) {
  //      this._dataService.setClassTypeId('2');
  //      this._dataService.setRegisterProgress('2');
  //      this._router.navigate(['select-location']);
  //    } else {
  //      // open modal with message
  //      this.displayModal = 'block';
  //    }
  //  }

  onModalClose() {
    this.displayModal = 'none';
  }

  onModalClose1() {
    this.displayModal1 = 'none';
  }

  createStudent() {
    // set SelectedMasterClassId in data sharing service.
    // get list of locations for this option (ClassMaster.id)
    // set those locations in the data sharing service.

    this.isModelChanged = false;
    this.isModel2Changed = false;
    this.saving = true;
    console.log(this.student);
    console.log(this.friendStudent);
    if (this.selectedState.id === '0') {
      if (this.student.address != null) {
        const anAddress = this.student.address;
        if (anAddress.stateId != null) {
          this.selectedState.id = anAddress.stateId;
        }
      }
    }

    this.formComplete = false;
    if (
      this.selectedState.id != '0' ||
      (this.isRegisteringAdditional && this.friendSelectedState.id != '0')
    ) {
      this.student.address.stateId = this.selectedState.id;
      this.student.contactMethodId = '1';
      this.student.studentSchoolId = '123';
      // this.student.studentTypeId = (this.isFullOnlineCourse) ? '1' : '2';
      if (this.student.studentTypeId == null) {
        this.student.studentTypeId = this._dataService.getClassTypeId();
      }
      if (this.isRegisteringAdditional) {
        let staddress = new AddressPost();
        staddress = this.friendStudent.address;
        staddress.stateId = this.friendSelectedState.id;
        this.friendStudent.address = staddress;
        // this.friendStudent.address.stateId = this.friendSelectedState.id;
        this.friendStudent.contactMethodId = '1';
        this.friendStudent.studentSchoolId = '123';
        this.student.friendStudent = this.friendStudent;
        // this.student.friendStudent.studentTypeId = (this.isFullOnlineCourse) ? '1' : '2';
        if (this.student.friendStudent.studentTypeId == null) {
          this.student.friendStudent.studentTypeId = this.student.studentTypeId;
        }
      } else {
        this.student.friendStudent = null;
      }
      this.fullAddress = 0;
      this.getGeocodeFromForm1();
    } else {
      // validation error on selected state or friend selected state
    }
  }

  getGeocodeFromForm1() {
    let address = '';
    if (this.fullAddress === +0) {
      address =
        this.student.address.address1 +
        ', ' +
        this.student.address.city +
        ', ' +
        this.selectedState.abbreviation +
        ' ';
    } else if ((this.fullAddress === +1) || (this.fullAddress === +2)) {
      address =
        this.student.address.city +
        ', ' +
        this.selectedState.abbreviation +
        ' ';
    } else if (this.fullAddress === +4) {
      address = this.selectedState.abbreviation + ' ';
    }
    if (this.fullAddress !== +2) {
      address +=
        (this.student.address.zipCode + '00000').substring(0, 5) + ' USA';
    }
    this._locationService.getGeocodeFromAddress(address).subscribe(
      (res) => this.getGeocodeFromForm1Success(res),
      (error) => this.getGeocodeFromForm1Failed(error),
      () => console.log('Get Geocode Complete!')
    );
  }
  getGeocodeFromForm1Failed(error: any) {
    const i = 1;
  }

  getGeocodeFromForm1Success(result: any) {
    const values = result;
    const res = values.results;
    if (res[0] != null && res[0].locations != null) {
      const loc = res[0].locations;
      if (loc[0] != null && loc[0].displayLatLng != null) {
        const displatlng = loc[0].displayLatLng;
        this.student.address.latitude = displatlng.lat;
        this.student.address.longitude = displatlng.lng;
      }
    }
    // If geocode is out of bounds, try again without address line (city, state, zip only)
    if (
      this.fullAddress < +4 &&
      (+this.student.address.longitude < -100 ||
        +this.student.address.latitude < 43)
    ) {
      this.fullAddress = this.fullAddress + 1;
      this.getGeocodeFromForm1();
    } else {
      this._studentService.saveStudent(this.student).subscribe(
        (res) => this.saveStudentSuccess(res),
        (error) => this.saveStudentFailed(error),
        () => console.log('Student Saved!')
      );
    }
  }

  saveStudentFailed(error: any) {
    this.saving = false;
    let additionalLogDetails: LogDetail[] = [];
    let studentData = JSON.stringify(this.student);
    let studentLogData = new LogDetail();
    let registrationLogData = new LogDetail();
    studentLogData.message = `Student Details: ${studentData}`;
    additionalLogDetails.push(studentLogData);
    additionalLogDetails.push(registrationLogData);
    this._logger
      .logError(
        error,
        'ERROR: [new-student-registration]',
        'saveStudent()',
        additionalLogDetails
      )
      .subscribe(
        (log) => this.logSuccessful(log),
        (error) => this.logFailed(error),
        () => console.log('LogError Complete!')
      );
  }

  saveStudentSuccess(result: any) {
    console.log(result);
    this._dataService.setCurrentStudent(result);
    const student = this._dataService.getCurrentStudent();
    this.student.id = student.student.id;
    let updateUser = this._dataService.getCurrentUser();
    this.updateUser.firstName = this.student.firstName;
    this.updateUser.middleName = this.student.middleName;
    this.updateUser.lastName = this.student.lastName;
    this.updateUser.email = this.student.email;
    this.updateUser.roleId = this._userService.roleStudent;
    if (this.userRole !== this._userService.roleStudent) {
      // logged in as Admin, creating/updating Student
      this.saveLoginSuccess(this.updateUser);
    } else if (updateUser !== null) {
      this.updateUser.id = updateUser.user.id;
      this.updateUser.password = updateUser.user.password;
      this._userService.updateLoginById(this.updateUser).subscribe(
        (res) => this.saveLoginSuccess(res),
        (error) => this.saveLoginFailed(error),
        () => console.log('User Saved!')
      );
    } else {
      updateUser = new CreateLogin();
    }
  }

  saveLoginFailed(error: any) {
    console.log('User Save Failed!');
  }

  saveLoginSuccess(result: any) {
    console.log(result);
    this._dataService.setCurrentUser(result);
    this._dataService.setRoleId(this.userRole); // If logged in as Admin, reset current user role
    this.saving = false;
    if (this.courseDeliveryType === 'classroom') {
      this._dataService.setRegisterAdditional(this.isRegisteringAdditional);
      this._dataService.setRegisterProgress('2');
      this._router.navigate(['select-location']);
    } else if (this.courseDeliveryType === 'online') {
      this._dataService.setRegisterOnlineProgress('2');
      window.open(
        'https://mnsafetycenter.interactyx.com/Pages/Catalog/CourseCatalog.aspx',
        '_blank'
      );
      // this._router.navigate(['payment-online-class']);
    } else {
      // user hit 'save changes'
      // show message for 2 seconds, then blank it
      this.msg = 'Changes saved';
      this.getStudent(); // Check if any classes
      setTimeout(() => {
        this.msg = '';
      }, 4000);
    }
  }

  regAddlChanged(event: any) {
    // this.selectedState = event;
    // this.student.address.stateId = this.selectedState.id;
    if (this.friendStudent == null) { this.friendStudent = new StudentPost(); }
    if (this.isAdmin && this.isRegisteringAdditional && this.friendStudent.id == '') {
      if (this.friendStudent.lastName == null || this.friendStudent.lastName === '')
       { this.friendStudent.lastName = this.student.lastName; }
      if (this.friendStudent.phone == null || this.friendStudent.phone === '')
       { this.friendStudent.phone = this.cvtPhone(this.student.phone); }
      if (this.friendStudent.cellPhone == null || this.friendStudent.cellPhone === '')
       { this.friendStudent.cellPhone = this.cvtPhone(this.student.cellPhone); }
      if (this.friendStudent.email == null || this.friendStudent.email === '')
       { this.friendStudent.email = this.student.email; }

      if (this.friendStudent.address.address1 == null || this.friendStudent.address.address1 === '')
       { this.friendStudent.address.address1 = this.student.address.address1; }
      if (this.friendStudent.address.address2 == null || this.friendStudent.address.address2 === '')
       { this.friendStudent.address.address2 = this.student.address.address2; }
      if (this.friendStudent.address.zipCode == null || this.friendStudent.address.zipCode === '')
       { this.friendStudent.address.zipCode = this.student.address.zipCode; }
      if (this.friendStudent.address.city == null || this.friendStudent.address.city === '')
       { this.friendStudent.address.city = this.student.address.city; }
      if (this.friendStudent.address.stateId == null || this.friendStudent.address.stateId === '')
       { this.friendStudent.address.stateId = this.student.address.stateId; }
    }
  }

  selectedStateChanged(event: any) {
    this.selectedState = event;
    this.student.address.stateId = this.selectedState.id;
    console.log('state changed to ' + this.selectedState.abbreviation);
  }

  friendSelectedStateChanged(event: any) {
    this.friendSelectedState = event;
    this.friendStudent.address.stateId = this.friendSelectedState.id;
    console.log('state changed to ' + this.friendSelectedState.abbreviation);
  }

  setDefaultClassType() {
    this.isFullOnlineCourse = true;
    this.isRefresherOnlineCourse = false;
    this.isFullClassroomCourse = true;
    this.isRefresherClassroomCourse = false;
    this.courseDeliveryType = this._dataService.getCourseDeliveryType();
    //    if (this.courseDeliveryType) {
    switch (this.courseDeliveryType) {
      case 'online':
        this.isFullOnlineCourse = true;
        this.isRefresherOnlineCourse = false;
        this.isFullClassroomCourse = true;
        this.isRefresherClassroomCourse = false;
        break;

      case 'classroom':
        this.isFullOnlineCourse = true;
        this.isRefresherOnlineCourse = false;
        this.isFullClassroomCourse = true;
        this.isRefresherClassroomCourse = false;
        break;

      default:
        this.isFullOnlineCourse = true;
        this.isRefresherOnlineCourse = false;
        this.isFullClassroomCourse = true;
        this.isRefresherClassroomCourse = false;
        this.courseDeliveryType = 'classroom';
        this._dataService.setCourseDeliveryType(this.courseDeliveryType);
        break;
    }
    //    }
  }

  logSuccessful(result: any) {}

  logFailed(error: any) {}
}



// WEBPACK FOOTER //
// ./src/app/new-student-registration/new-student-registration.component.ts